//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

    export default {
        data() {
            return {
                signOption: {
                    penColor: "rgb(0, 0, 0)"
                },
            }
        },
    }



// WEBPACK FOOTER //
// ./src/components/design/components/control/sy-sign.vue